import React from 'react';

const LoaderOverlay = () => {
    const overlayStyle = {
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        background: '#000',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 9999
    };

    const spinnerStyle = {
        border: '5px solid #f3f3f3',
        borderTop: '5px solid red',
        borderRadius: '50%',
        width: '60px',
        height: '60px',
        animation: 'spin 0.8s linear infinite'
    };

    const spinKeyframes = `
        @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
        }
    `;

    return (
        <>
            <style>{spinKeyframes}</style>
            <div style={overlayStyle}>
                <div style={spinnerStyle}></div>
            </div>
        </>
    );
};

export default LoaderOverlay;
